// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-dele-socios {\n    font-size: 14px;\n    padding: 8px !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
